import React from "react";
import { ValidationErrorMessage } from "react-admin";
import { Controller, FieldValues } from "react-hook-form";
import { VehiclePicker } from "../../VehiclePicker";
import { HookFormInputProps } from "./HookFormInputProps";

interface Props<TRecord> extends HookFormInputProps<TRecord> {
  margin?: "none" | "dense" | "normal";
  variant?: "standard" | "outlined" | "filled";
}

const HookFormVehiclePickerComponent = <TRecord extends FieldValues>(
  {
    control,
    name,
    defaultValue,
    label,
    rules,
    margin,
    variant,
    options,
  }: Props<TRecord>,
  ref: React.Ref<HTMLDivElement>
) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue ?? ""}
      rules={rules}
      render={(renderProps) => (
        <VehiclePicker
          label={label}
          margin={margin}
          variant={variant}
          options={options}
          {...renderProps.field}
          touched={renderProps.fieldState.isTouched}
          error={
            (renderProps.fieldState.error as any)
              ?.message as ValidationErrorMessage
          }
          helperText={(renderProps.fieldState.error as any)?.message as string}
          inputRef={renderProps.field.ref}
        />
      )}
    />
  );
};

export const HookFormVehiclePicker = React.forwardRef(
  HookFormVehiclePickerComponent
);
